<template>
    <main-layout>
        <div class="container">
          <br><br><br>
            <H1 class="pageTitle isPoppins">Privacy Policy</H1>
            
            <div class="accSettingsForm top20">
                <p class=MsoNormal><span style='font-family:"Arial",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-theme-font:minor-latin'>This
Privacy Policy governs the <span class=GramE>manner in which</span> Slink, Inc.
collects, uses, maintains and discloses information collected from its users
(each, a “User”) through the www.slink.com website (“Site”). This Privacy
Policy applies to the Site and all services arising therefrom provided by Slink,
Inc.</span></p>
<br>
<p class=MsoNormal><span style='font-family:"Arial",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-theme-font:minor-latin'>Last
Modified: May 4<sup>th</sup>, 2021<br>



<p class=MsoNormal><span style='font-family:"Arial",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-theme-font:minor-latin'>&nbsp;</span></p>

<b>Personal Identification Information</b><br>
<br>
We may collect personal identification information from prospective and/or
active Users in a variety of ways, including, but not limited to, when visiting
our Site, registering on the Site to become a User, subscribing to certain
services, and/or in connection with other activities, <span class=GramE>features</span>
or resources we make available from time-to-time on our Site. To register to
become a User, the viewer may be asked for, as appropriate, name, email
address, mailing address, phone number, and/or credit card information. Viewers
may also, however, visit our Site anonymously. We will collect personal
identification information from prospective Users only if they voluntarily
submit such information to us. Prospective Users can always refuse to supply
certain personal identification information, except that it may prevent them
from engaging in certain Site related activities.<br>
<br>
<b>Non-personal Identification Information</b><br>
<br>
We may collect non-personal identification information whenever a Viewer
interacts with our Site. Non-personal identification information may include,
but may not be limited to, the Viewer’s browser name, the type of computer, and
technical information about the means of connection to our Site, such as the
operating system and the Internet service providers utilized and other similar
information.<br>
<br>
<b>Web Browser Cookies</b><br>
<br>
Our Site uses “cookies” to enhance the Viewer experience. Web browsers place
cookies on a Viewer’s hard drive for record-keeping purposes and sometimes to
track information about them. We use cookies to track items within shopping
carts and to maintain session information on logged in users so that they do
not have to log in every time they visit the Site.<span
style='mso-spacerun:yes'>  </span>Viewers may choose to set their web browser
to refuse cookies, or set alerts when cookies are being sent. If a Viewer takes
these actions, some sections of our Site may not function properly for the
Viewer.<br>
<br>
<b>How We Use Collected Information</b><br>
<br>
Slink, Inc may collect and use personal information described above for the
following purposes:<br>
- To improve customer service<br>
- To help us respond to customer service requests and support needs more
efficiently<br>
- To personalize the Viewer experience<br>
- To understand how our Viewers, as a group, use our services and resources
provided on our Site<br>
- To improve our Site<br>
- To receive feedback to improve our products and services<br>
- To process payments<br>
- To provide service and support for a User’s order. We do not share this
information with outside parties except to the extent necessary to provide the
service<br>
- To send periodic emails<br>
- To send Users certain information and updates pertaining to any order. We may
also use it to respond to inquiries, questions, and/or other requests</span></p>

<p class=MsoNormal><span style='font-family:"Arial",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-theme-font:minor-latin'><br>
By opting-in to our mailing lists, a User agrees to receive emails that may
include company news, updates, related <span class=GramE>product</span> or
service information, etc. If at any time that person would like to unsubscribe
from receiving future emails, we include detailed unsubscribe instructions at
the bottom of each email.<br>
<br>
<b>How We Protect Your Information</b><br>
<br>
We adopt appropriate data collection, storage and processing practices and
security measures to protect against unauthorized access, alteration,
disclosure or destruction of your personal information, username, password,
transactional <span class=GramE>information</span> and data stored on our Site.
Sensitive and private data exchanged between our Site and its Users occurs over
an SSL secured communication channel and is encrypted and protected with
digital signatures. Slink, Inc., does not store credit card information, rather
this process is outsourced to a third-party payment provider, Stripe.com.<span
style='mso-spacerun:yes'>  </span>For information about how they handle this
information please visit their website.<br>
<br>
<b>Sharing Your Personal Information</b><br>
<br>
We do not sell, trade, or rent personal identification information to others.
We may share generic aggregated demographic information not linked to any
personal identification information regarding visitors and users with our
business partners, trusted affiliates and advertisers for the purposes outlined
above.</span></p>

<p class=MsoNormal><span style='font-family:"Arial",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-theme-font:minor-latin'>&nbsp;</span></p>

<p class=MsoNormal><span style='font-family:"Arial",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-theme-font:minor-latin'>
<b>Deleting Your Account</b></span></p>

<p class=MsoNormal><span style='font-family:"Arial",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-theme-font:minor-latin'>&nbsp;</span></p>

<p class=MsoNormal><span style='font-family:"Arial",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-theme-font:minor-latin'>If
you would like to delete your account and all data related to it, please send a
request using the DELETE ACCOUNT button within the Account Settings page of the site.<span
style='mso-spacerun:yes'>  </span><span style='mso-spacerun:yes'></span>In no event will we issue refunds
to services you have paid for <span class=GramE>as a result of</span> a request
for account deletion. We will notify you once the deletion has been completed.
NOTE: You must be logged into your account to perform this action.</span></p>

<p class=MsoNormal><span style='font-family:"Arial",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-theme-font:minor-latin'>&nbsp;</span></p>

<p class=MsoNormal><span style='font-family:"Arial",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-theme-font:minor-latin'>
<b>Getting a Copy of Your Data</b></span></p>

<p class=MsoNormal><span style='font-family:"Arial",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-theme-font:minor-latin'>&nbsp;</span></p>

<p class=MsoNormal><span style='font-family:"Arial",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-theme-font:minor-latin'>If
you would like to receive a copy of the data we have stored in connection to
your account, please send a request using the SEND REQUEST button within the Account Settings page of the site. Please note that data
request will be delivered by email only to the email address registered to the
account.<span style='mso-spacerun:yes'>  </span>If you are not a registered
User of our site, we store no personally identifiable data about you and
therefore cannot provide you with a copy of your data. NOTE: You must be logged
into your account to perform this action.</span></p>

<p class=MsoNormal><span style='font-family:"Arial",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-theme-font:minor-latin'>&nbsp;</span></p>

<p class=MsoNormal><span style='font-family:"Arial",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-theme-font:minor-latin'><br>
<b>Third Party Websites</b><br>
<br>
Viewers may find advertising or other content on our Site that link to the
sites and services of our partners, suppliers, advertisers, sponsors, licensors
and other third parties. We do not control the content or links that appear on
these sites and are not responsible for the practices employed by websites
linked to or from our Site. In addition, these <span class=GramE>sites</span>
or services, including their content and links, may be constantly changing.
These sites and services may have their own privacy policies and customer
service policies. Browsing and interaction on any other website, including
websites which have a link to our Site, is subject to that website’s own terms
and policies.<br>
<br>
<b>Advertising</b><br>
<br>
Ads appearing on our site may be delivered by advertising partners, who may set
cookies. These cookies may allow the advertiser’s server to recognize your
computer, each time they send you an online advertisement, to compile non
personal identification information about you or others who use your computer.
This information allows advertising networks to, among other things, deliver
targeted advertisements that they believe will be of most interest to you. This
privacy policy does not cover the use of cookies by any advertiser.<br>
<br>
<b>Changes to this Privacy Policy</b><br>
<br>
Slink, Inc., has the discretion to update this privacy policy at any time. When
we do, we will revise the “updated” date at the bottom of the applicable page.
We encourage frequent checking of this page for any changes to stay informed
about how we are helping to protect information we collect. You acknowledge and
agree that it is your responsibility to review this privacy policy periodically
and become aware of any modifications.<br>
<br>
<b>Your Acceptance of these Terms</b><br>
<br>
By using this Site, you signify your acceptance of this Policy. If you do not
agree to this policy, do not use our Site. In addition, your continued use of
the Site, following the posting of changes to this Policy, will be deemed your
acceptance of those changes.<br>
<br>
<b>GDPR Representative in the EU</b><br>
<br>
Gustavo Medina del Rosario<br>
The Singular Factory SL<br>
Avenida Pintor Felo Monzón, 34 - Bajo<br>
35019 Las Palmas de Gran Canaria<br>
Islas Canarias, España<br>
<br>
<b>Contacting Us</b><br>
<br>
If you have any questions about this Privacy Policy, the practices of this
site, or your dealings with this site, please contact us at:</span></p>

<p ><span> <a style="color: white" href="mailto:legal@slink.com"><b>legal@slink.com</b></a></span></p>
            </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'

export default {
  components: {
    MainLayout
  },
  mounted: function () {
    window.scrollTo(0,0)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Privacy.vue